module.exports = __webpack_public_path__ + "images/img_1.png";